var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "requirement-analysis" }, [
    _c("div", { ref: "fixTopComponent", staticClass: "side-menu-box" }, [
      _c("div", { staticClass: "menuFixed" }, [
        _c(
          "div",
          { staticClass: "side-menu" },
          _vm._l(_vm.menuList, function (item) {
            return _c(
              "a",
              {
                key: item.id,
                staticClass: "menu-item flex items-center",
                class: {
                  active: item.id === _vm.menuCurrent,
                },
                on: {
                  click: function ($event) {
                    return _vm.changeMenu($event, item.id)
                  },
                },
              },
              [_c("span", [_vm._v(_vm._s(item.label))])]
            )
          }),
          0
        ),
        _c("div", { staticClass: "addNew", on: { click: _vm.handleBack } }, [
          _c("i", {
            staticClass: "el-icon-plus",
            staticStyle: { "font-size": "14px" },
          }),
          _vm._v("创建新对话"),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "menu-content relative" }, [
      _c(
        "div",
        {
          staticClass: "flex items-center justify-end export-pdf-box",
          staticStyle: { height: "36px" },
        },
        [
          _c(
            "el-button",
            {
              staticClass: "export-pdf",
              attrs: {
                type: "text",
                disabled: _vm.status !== "SUCCESS",
                loading: _vm.pdfLoading,
              },
              on: { click: _vm.exportPdf },
            },
            [_vm._v("导出PDF")]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          ref: "requirementContainer",
          staticClass: "scroll-content",
          on: { scroll: _vm.watchScroll },
        },
        [
          _c(
            "div",
            { staticClass: "think-content" },
            [
              _c(
                "toggle-component",
                {
                  ref: "toggleRef2",
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: { "default-visible": true },
                },
                [
                  _c("div", {
                    staticClass: "markdown-body",
                    domProps: { innerHTML: _vm._s(_vm.thinkingMd) },
                  }),
                ]
              ),
              _vm.thinkLoading
                ? _c("p", { staticClass: "load-text" }, [
                    _c("i", { staticClass: "el-icon-loading" }),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm.reportLoading
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "content-bg",
                    staticStyle: { "margin-bottom": "0" },
                  },
                  [
                    _c("p", [_vm._v("正在生成报告")]),
                    _vm.reporterMd
                      ? _c("p", {
                          staticClass: "markdown-body",
                          domProps: { innerHTML: _vm._s(_vm.reporterMd) },
                        })
                      : _vm._e(),
                    _vm.reportLoading
                      ? _c("p", { staticClass: "load-text" }, [
                          _c("i", { staticClass: "el-icon-loading" }),
                        ])
                      : _vm._e(),
                  ]
                ),
              ])
            : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isStreaming && _vm.requirementData,
                  expression: "!isStreaming && requirementData",
                },
              ],
              staticClass: "list-container",
              staticStyle: { "margin-top": "20px" },
            },
            _vm._l(_vm.menuList, function (item, i) {
              return _c(
                "div",
                { key: i, staticClass: "list-item", attrs: { id: item.id } },
                [
                  _c("div", { staticClass: "flex" }, [
                    _c("img", {
                      staticStyle: { "margin-right": "5px" },
                      attrs: {
                        width: "28",
                        height: "18",
                        src: _vm.titleLeft,
                        alt: "",
                      },
                    }),
                    _c("div", { staticClass: "title-bg" }, [
                      _c(
                        "div",
                        {
                          staticClass: "flex justify-center",
                          staticStyle: { padding: "0 6px" },
                        },
                        [_vm._v(_vm._s(item.label))]
                      ),
                      _c("div", { staticClass: "title-bottom" }),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loadingData,
                          expression: "loadingData",
                        },
                      ],
                      staticClass: "content-bg",
                    },
                    [
                      !_vm.requirementData[item.label]
                        ? _c("el-empty", { attrs: { "image-size": 140 } })
                        : _c("div", [
                            _c("p", {
                              staticClass: "markdown-body",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.requirementData[item.label]
                                ),
                              },
                            }),
                          ]),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          ),
        ]
      ),
    ]),
    _c("div", { staticStyle: { "margin-left": "13px" } }, [
      _c("div", { staticClass: "flex" }, [
        _c("img", {
          staticStyle: { "margin-right": "5px" },
          attrs: { width: "28", height: "18", src: _vm.titleLeft },
        }),
        _vm._m(0),
      ]),
      _c("div", { staticClass: "correlation" }, [
        _c(
          "div",
          { staticClass: "flex", staticStyle: { padding: "17px 20px 0" } },
          _vm._l(_vm.correlationTitleList, function (item, i) {
            return _c(
              "div",
              {
                key: i,
                class:
                  _vm.activeCorrelation === item
                    ? "correlation-item-click"
                    : "correlation-item",
                on: {
                  click: function ($event) {
                    return _vm.activeCo(item)
                  },
                },
              },
              [_vm._v(" " + _vm._s(item) + " ")]
            )
          }),
          0
        ),
        _c(
          "div",
          {
            ref: "scrollContainer",
            staticStyle: {
              "max-height": "calc(100vh - 130px)",
              "overflow-y": "auto",
            },
          },
          [
            _vm.activeCorrelation === "专家"
              ? _c("person-list", {
                  attrs: {
                    "person-data": _vm.achievementData.scholar,
                    "talent-loading": _vm.achievementLoading,
                  },
                })
              : _vm._e(),
            _vm.activeCorrelation === "机构"
              ? _c("org-list", {
                  attrs: {
                    "org-data": _vm.achievementData.org,
                    "talent-loading": _vm.achievementLoading,
                  },
                })
              : _vm._e(),
            _vm.activeCorrelation === "论文"
              ? _c("paper-list", {
                  attrs: {
                    "ach-data": _vm.achievementData.paper,
                    "talent-loading": _vm.achievementLoading,
                  },
                })
              : _vm._e(),
            _vm.activeCorrelation === "专利"
              ? _c("patent-list", {
                  attrs: {
                    "ach-data": _vm.achievementData.patent,
                    "talent-loading": _vm.achievementLoading,
                  },
                })
              : _vm._e(),
            _vm.activeCorrelation === "项目"
              ? _c("project-list", {
                  attrs: {
                    "ach-data": _vm.achievementData.project,
                    "talent-loading": _vm.achievementLoading,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title-bg" }, [
      _c(
        "div",
        {
          staticClass: "flex justify-center",
          staticStyle: { padding: "0 6px" },
        },
        [_vm._v("相关文献")]
      ),
      _c("div", { staticClass: "title-bottom" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }